import AppRouter from '../../AppRouter';
import HeaderWrapper from '../HeaderWrapper';
import 'react-toastify/dist/ReactToastify.css';
import { Button, NotificationContainer, Footer } from '@airdao/ui-library';
import { ReactComponent as BookIcon } from '../../assets/icons/book-icon.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/info-icon.svg';
import { ReactComponent as ChatHelpIcon } from '../../assets/icons/chat-help-icon.svg';
import useGtag from '../../hooks/useGtag';
import { useLocation } from 'react-router-dom';

const Layout = () => {
  useGtag();
  const location = useLocation();

  return (
    <>
      <HeaderWrapper />
      <div className="layout">
        {!location.pathname.includes('/exchange/') && (
          <>
            <div className="bg-circle bg-circle_left" />
            <div className="bg-circle bg-circle_right" />
          </>
        )}
        <AppRouter />
      </div>
      <div className="bond-help">
        {/*<a*/}
        {/*  href='https://airdao.academy/guides/bridge'*/}
        {/*  target='_blank'*/}
        {/*  rel='noreferrer nofollow'*/}
        {/*>*/}
        {/*  <Button size='large' type='tetiary' leadIcon={<BookIcon />}>*/}
        {/*    Learn about bonds*/}
        {/*  </Button>*/}
        {/*</a>*/}
        {/*<a href='https://airdao.academy/' target='_blank' rel='nofollow noreferrer'>*/}
        {/*  <Button size='large' type='tetiary' leadIcon={<InfoIcon />}>*/}
        {/*    Guides*/}
        {/*  </Button>*/}
        {/*</a>*/}
        <a href='https://airdao.io/contact-us' target='_blank' rel='noreferrer'>
          <Button size='large' type='tetiary' leadIcon={<ChatHelpIcon />}>
            Support
          </Button>
        </a>
      </div>
      <Footer />
      <NotificationContainer />
    </>
  );
};

export default Layout;
